<div class="customer-info-container flex flex-column gap-3 mb-5">
  <div>
    <div class="pb-4">
      <div>
        <span class="title">
          <app-translate key="PERSONAL_INFORMATION"></app-translate>
        </span>
      </div>
      <div class="sub-title">
        <app-translate key="PLEASE_FILL_OUT_INFORMATION"></app-translate>
      </div>
    </div>
    <p-divider></p-divider>
  </div>

  <!-- Form -->
  @if (customerInformationForm) {
    <div>
      <sp-form-wrapper [formGroup]="customerInformationForm" id="customerInformationForm">
        <div class="grid">
          <div class="col-12">
            <div class="grid">
              <div class="col-12 md:col-6">
                <div class="flex flex-column flex-1">
                  <label htmlFor="firstName" class="form-label"><app-translate
                  key="FIRST_NAME"></app-translate></label>
                  <input type="text" [placeholder]="'FIRST_NAME' | translate" pInputText
                    formControlName="firstName" class="mb-1 skinny w-full sara-error"
                    (focus)="sendCustomerInputMessage('first name')" />
                  <sp-control-error [parameters]="['FIRST_NAME' | translate]"
                    [messagesParameters]="[{key : 'pattern', message : 'ENTER_VALID_FIRST_NAME' | translate}]"
                  [control]="customerInformationForm.controls['firstName']"></sp-control-error>
                </div>
              </div>
              <div class="col-12 md:col-6">
                <div class="flex flex-column flex-1">
                  <label htmlFor="lastName" class="form-label"><app-translate
                  key="LAST_NAME"></app-translate></label>
                  <div class="flex align-items-center">
                    <input type="text" [placeholder]="'LAST_NAME' | translate" pInputText
                      (focus)="sendCustomerInputMessage('last name')" formControlName="lastName"
                      class=" w-full flex-1 mb-0 skinny sara-error" />
                  </div>
                  <sp-control-error [parameters]="['LAST_NAME' | translate]"
                    [control]="customerInformationForm.controls['lastName']"
                  [messagesParameters]="[{key : 'pattern', message : 'ENTER_VALID_LAST_NAME' | translate}]"></sp-control-error>
                </div>
              </div>
              <div class="col-12 md:col-6">
                <div class="flex flex-column flex-1">
                  <label htmlFor="serviceAddress" class="form-label">
                    <app-translate key="SERVICE_ADDRESS"></app-translate>
                  </label>
                  <div class="flex align-items-stretch">
                    <p-autoComplete #autoComplete formControlName="serviceAddress"
                      [suggestions]="filteredAddresses" class="w-full sara-service-address"
                      [inputStyleClass]="'w-full skinny-select'" [styleClass]="'w-full'"
                      (completeMethod)="filterAddress($event)" (onSelect)="onAddressSelect($event)"
                      [optionLabel]="'label'" [optionValue]="'value'" [showClear]="true"
                      [placeholder]="'ENTER_ADDRESS' | translate" (onClear)="clearAddressSection()"
                      (onFocus)="sendCustomerInputMessage('service address')" [size]="'small'">
                    </p-autoComplete>
                  </div>
                  <div>
                    <sp-control-error [parameters]="['SERVICE_ADDRESS' | translate]"
                      [control]="customerInformationForm.controls['serviceAddress']"
                    [messagesParameters]="[{key : 'poBox', message : 'PO_BOX_NOT_ALLOWED' | translate}]"></sp-control-error>
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6">
                <div class="flex flex-column flex-1">
                  <label htmlFor="lastName" class="form-label"><app-translate
                  key="CITY"></app-translate></label>
                  <div class="flex align-items-center">
                    <input type="text" [placeholder]="'CITY' | translate" pInputText
                      (focus)="sendCustomerInputMessage('city')" formControlName="city"
                      class=" w-full flex-1 mb-0 skinny sara-error" />
                  </div>
                  <sp-control-error [parameters]="['CITY' | translate]"
                    [control]="customerInformationForm.controls['city']"
                  [messagesParameters]="[{key : 'pattern', message : 'ENTER_VALID_CITY' | translate}]"></sp-control-error>
                </div>
              </div>
              <div class="col-6">
                <div class="flex flex-column flex-1">
                  <label htmlFor="lastName" class="form-label"><app-translate
                  key="STATE"></app-translate></label>
                  <div class="flex align-items-center">
                    <p-select [options]="states" formControlName="state" optionLabel="abbreviation"
                      [placeholder]="'SELECT_STATE' | translate" class="w-full"
                      styleClass="skinny w-full" [filter]="true" filterBy="abbreviation"
                      optionValue="abbreviation" (onFocus)="sendCustomerInputMessage('state')">
                      <ng-template pTemplate="selectedItem" let-selectedOption>
                        <div>{{ selectedOption.abbreviation }}</div>
                      </ng-template>
                    </p-select>
                  </div>
                  <sp-control-error [parameters]="['STATE' | translate]"
                    [control]="customerInformationForm.controls['state']"
                  [messagesParameters]="[{key : 'pattern', message : 'SELECT_VALID_STATE' | translate}]"></sp-control-error>
                </div>
              </div>
              <div class="col-6">
                <div class="flex flex-column flex-1">
                  <label htmlFor="lastName" class="form-label"><app-translate
                  key="ZIP_CODE"></app-translate></label>
                  <div>
                    <p-inputMask type="tel" [autoClear]="false" mask="99999?-9999" formControlName="zipCode"
                      [placeholder]="'ENTER_ZIP_CODE' | translate" styleClass="w-full mb-1 skinny"
                      (onBlur)="validateAddress()"
                    (onFocus)="sendCustomerInputMessage('zip code')"></p-inputMask>
                  </div>
                  <sp-control-error [parameters]="['ZIP_CODE' | translate]"
                    [control]="customerInformationForm.controls['zipCode']"
                  [messagesParameters]="[{key : 'pattern', message : 'ENTER_VALID_ZIP' | translate}]"></sp-control-error>
                </div>
              </div>
              <div class="col-12">
                <div class="flex flex-row">
                  <div class="mr-3 flex">
                    <p-button #showFullAddressBtn class="text-decoration-none"
                      [styleClass]="'pr-0 text-decoration-none outline-none pl-0'"
                      icon="pi pi-map-marker" (onClick)="showFullAddress = !showFullAddress"
                    [label]="'SHOW_FULL_ADDRESS' | translate" [link]="true" size="small"></p-button>
                    <i [ngClass]="{'pi-angle-up': showFullAddress, 'pi-angle-down': !showFullAddress, 'pi pt-2 color-sara-blue': true }"
                      (click)="showFullAddress = !showFullAddress"
                    (keyup)="showFullAddress = !showFullAddress" tabindex="0"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (showFullAddress) {
            <div class="col-12">
              <ng-container>
                <div class="mt-2">
                  <div class="flex flex-column md:flex-row gap-3">
                    <div class="pr-2 flex flex-column">
                      <label htmlFor="unitType" class="form-label"><app-translate
                      key="TYPE"></app-translate></label>
                      <p-select formControlName="unitType" [options]="unitTypes" [optionLabel]="'label'"
                        [optionValue]="'value'" [placeholder]="'SELECT_TYPE' | translate"
                        [styleClass]="'skinny-select w-11rem'"
                        (onFocus)="sendCustomerInputMessage('unit type')" />
                    </div>
                    <div class="flex flex-column">
                      <label htmlFor="unitNumber" class="form-label"><app-translate
                      key="NUMBER"></app-translate></label>
                      <input type="text" [placeholder]="'ENTER_NUMBER' | translate" pInputText
                        formControlName="unitNumber" class="mb-1 skinny"
                        (focus)="sendCustomerInputMessage('unit number')" />
                    </div>
                  </div>
                  @if (!displayStructureType) {
                    <div class="flex flex-column">
                      <p-button icon="pi-plus-sara" [label]="'ADD_STRUCTURE_TYPE' | translate" [link]="true"
                        styleClass="outline-none text-decoration-none text-sm font-light pl-0 mr-8 pr-8"
                      (onClick)="displayStructureType = !displayStructureType"></p-button>
                    </div>
                  }
                  @if (displayStructureType) {
                    <div class="mt-3 flex flex-column md:flex-row gap-3">
                      <div class="mr-2 flex flex-column flex-shrink-0">
                        <label htmlFor="structureType" class="form-label">
                          <app-translate key="STRUCTURE"></app-translate>
                        </label>
                        <p-select formControlName="structureType" [options]="structureTypes"
                          [placeholder]="'SELECT_STRUCTURE' | translate"
                          [styleClass]="'skinny-select flex-shrink-0 w-11rem'"
                          (onFocus)="sendCustomerInputMessage('structure type')" />
                      </div>
                      <div class="flex flex-column">
                        <label htmlFor="structureNumber" class="form-label">
                          <app-translate key="NUMBER"></app-translate>
                        </label>
                        <div class="flex flex-row">
                          <input type="text" [placeholder]="'ENTER_NUMBER' | translate" pInputText
                            formControlName="structureNumber" class="mb-1 skinny"
                            (focus)="sendCustomerInputMessage('structure number')" />
                          <p-button icon="pi pi-minus-circle" [label]="'REMOVE' | translate" [link]="true"
                            styleClass="outline-none text-decoration-none text-sm font-light pl-3 mr-8 pr-8"
                          (onClick)="removeStructure()"></p-button>
                        </div>
                      </div>
                    </div>
                  }
                  @if (displayStructureType && !displayFloor) {
                    <div class="flex flex-column">
                      <p-button icon="pi-plus-sara" [label]="'ADD_FLOOR' | translate" [link]="true"
                        styleClass="outline-none text-decoration-none text-sm font-light pl-0 mr-8 pr-8"
                      (onClick)="displayFloor = !displayFloor"></p-button>
                    </div>
                  }
                  @if (displayFloor) {
                    <div class="mt-3 flex flex-column md:flex-row">
                      <div class="pr-2 flex flex-column">
                        <label htmlFor="floor" class="form-label">
                          <app-translate key="FLOOR_NUMBER"></app-translate>
                        </label>
                        <div class="flex flex-row">
                          <input type="text" [placeholder]="'ENTER_FLOOR_NUMBER' | translate" pInputText
                            formControlName="floor" class="mb-1 skinny"
                            (focus)="sendCustomerInputMessage('floor number')" />
                          <p-button icon="pi pi-minus-circle" [label]="'REMOVE' | translate" [link]="true"
                            styleClass="outline-none text-decoration-none text-sm font-light pl-3 mr-8 pr-8"
                          (onClick)="removeFloor()"></p-button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </ng-container>
            </div>
          }
          <div class="col-12">
            <div class="grid">
              <div class="col-12 md:col-6">
                <div class="flex">
                  <app-email-verification #emailVerificationComponent class="flex-auto"
                    styleClass="flex-auto" [control]="customerInformationForm.controls['email']"
                    [controlName]="'email'" [formGroupRef]="customerInformationForm"
                    [showSearchIcon]="false" [showLabel]="false" (verificationStatus)="onApiEmailValidation($event)"
                    [isAlreadyVerifiedByCustomer]="isEmailVerifiedByCustomer"
                  (onChangeInputFocus)="sendCustomerInputMessage('email')"></app-email-verification>
                </div>
              </div>
              <div class="col-12 md:col-6">
                <div class="flex">
                  <app-phone-verification class="flex-auto" styleClass="flex-auto"
                    [control]="customerInformationForm.controls['phone']" [controlName]="'phone'"
                    [formGroupRef]="customerInformationForm"  [showLabel]="false" [hideValidatePhone]="false" [showSearchIcon]="false"
                    [isAlreadyVerifiedByCustomer]="isPhoneVerifiedByCustomer"
                    (verificationStatus)="onApiPhoneValidation($event)"
                  (onChangeInputFocus)="sendCustomerInputMessage('phone')"></app-phone-verification>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="mb-1 flex flex-column">
            @if (customerInformationForm.get('canContact')) {
              <div class="flex items-center">
                <div>
                  <p-checkbox
                    [ngStyle]="{'border': customerInformationForm.get('canContact')?.touched && customerInformationForm.get('canServiceProviderContact')?.invalid ? '1px solid red' : 'none'}"
                    formControlName="canContact" [binary]="true" inputId="binary"
                    (onFocus)="sendCustomerInputMessage('Customer is checking service provider', false)" />
                </div>
                <label for="binary" class="pl-2 form-label">
                  <app-translate key="SERVICE_PROVIDER_CONTACT_PERMISSION"></app-translate>
                </label>
              </div>
            }
            <div>
              <sp-control-error [control]="customerInformationForm.controls['canContact']"
              [messagesParameters]="[{key : 'required', message : 'FIELD_REQUIRED' | translate}]"></sp-control-error>
            </div>
          </div>
        </div>
        <!-- Business Information (smbnew only) -->
        @if (isSMB) {
          <div class="col-12">
            <div class="pb-3 pt-2">
              <p-divider></p-divider>
              <div class="text-center">
                <span class="title">
                  <app-translate key="BUSINESS_INFORMATION"></app-translate>
                </span>
              </div>
            </div>
            <div class="grid">
              <!-- Business Name -->
              <div class="col-12">
                <div class="flex flex-column flex-1">
                  <label htmlFor="businessNameSMB" class="form-label">
                    <app-translate key="BUSINESS_NAME"></app-translate>
                  </label>
                  <input type="text" [placeholder]="'ENTER_BUSINESS_NAME' | translate" pInputText
                    formControlName="businessNameSMB" class="mb-1 skinny w-full sara-error" maxlength="200"
                    (focus)="sendCustomerInputMessage('business name')" />
                  <sp-control-error [parameters]="['BUSINESS_NAME' | translate]"
                  [control]="customerInformationForm.controls['businessNameSMB']"></sp-control-error>
                </div>
              </div>
              <!-- Business Type -->
              <div class="col-12">
                <div class="flex flex-column flex-1">
                  <label htmlFor="businessTypeSMB" class="form-label">
                    <app-translate key="BUSINESS_TYPE"></app-translate>
                  </label>
                  <p-select formControlName="businessTypeSMB" [options]="businessTypeOptionsSMB"
                    optionLabel="label" optionValue="value" [placeholder]="'SELECT_ONE' | translate"
                    class="w-full" styleClass="skinny w-full"
                  (onFocus)="sendCustomerInputMessage('business type')"></p-select>
                  <sp-control-error [parameters]="['BUSINESS_TYPE' | translate]"
                  [control]="customerInformationForm.controls['businessTypeSMB']"></sp-control-error>
                </div>
              </div>
              <!-- EIN / Tax ID — hidden for Sole Proprietor -->
              @if (customerInformationForm.get('businessTypeSMB')?.value !== 'sole-prop') {
                <div class="col-12"
                  >
                  <div class="flex flex-column flex-1">
                    <label htmlFor="businessTaxIdSMB" class="form-label">
                      <app-translate key="EIN_TAX_ID"></app-translate>
                    </label>
                    <p-iconField iconPosition="right" class="w-full sara-tax-id-field">

                      <input type="text" inputmode="tel" pInputText formControlName="businessTaxIdSMB"
                        [class.app-text-masked]="!showTaxId" class="mb-1 skinny w-full sara-error"
                        [placeholder]="'ENTER_TAX_ID' | translate" appNumericOnly maxlength="10"
                        (input)="onTaxIdInput($event)"
                        (focus)="sendCustomerInputMessage('tax id')" />
                      <p-inputIcon [styleClass]="(showTaxId ? 'pi pi-eye-slash' : 'pi pi-eye') + ' cursor'"
                        (click)="showTaxId = !showTaxId" />
                    </p-iconField>
                    <sp-control-error [parameters]="['EIN_TAX_ID' | translate]"
                      [control]="customerInformationForm.controls['businessTaxIdSMB']"
                    [messagesParameters]="[{key : 'pattern', message : 'ENTER_VALID_TAX_ID' | translate}]"></sp-control-error>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <div>
          <div class="mb-3">
            <p-button (onClick)="onSubmitClicked()" styleClass="p-button-lg w-full p-button-primary">
              <app-translate key="SUBMIT"></app-translate>
            </p-button>
          </div>
          <div class="mb-3">
            <p-button [link]="true" styleClass="w-full" (onClick)="onCancelClick()">
              <app-translate key="CANCEL"></app-translate>
            </p-button>
          </div>
        </div>
        <div>
          <span class="sub-title">
            <app-translate key="PRIVATE_INFO_SECURITY"></app-translate>
          </span>
        </div>
      </sp-form-wrapper>
    </div>
  }
</div>

<app-confirm-popup [title]="'CANCEL_CONFIRMATION_TEXT' | translate" [header]="'CONFIRM_CANCELLATION' | translate"
[(isVisible)]="showCancelDialog" (Result)="onCancel($event)"></app-confirm-popup>

<app-confirm-popup [title]="addressConfirmationText" [header]="'CONFIRM_ADDRESS' | translate"
  [(isVisible)]="showAddressConfirmPopup" (Result)="onConfirmAddressPopupResult($event)">
  <ng-template pTemplate="title">
    <span class="sub-title">
      <app-translate key="ADDRESS_CONFIRMATION_QUESTION"></app-translate>
      <br />
      <b>
        {{addressConfirmationText}}
      </b>
    </span>
  </ng-template>
</app-confirm-popup>